import TableToolbar from './TableToolbar';
import CommitteeTableHeader from './CommitteeTableHeader';
import CommitteeRow from './CommitteeRow';
import TablePagination from './TablePagination';

export interface Committee {
  id: number;
  name: string;
  type: string;
  schedule: string;
  role: string;
  members: number;
  cadence: string;
  status: string;
}

export const committeesData: Committee[] = [
  {
    id: 1,
    name: 'BMC',
    type: 'Governance Committee',
    schedule: 'Aug 07, 2026',
    role: 'Advisory',
    members: 18,
    cadence: 'Weekly',
    status: 'Active',
  },
  {
    id: 2,
    name: 'ASSA',
    type: 'Executive Committee',
    schedule: 'Aug 07, 2026',
    role: 'Advisory',
    members: 18,
    cadence: 'Weekly',
    status: 'Active',
  },
  {
    id: 3,
    name: 'AA',
    type: 'Governance Committee',
    schedule: 'Aug 07, 2026',
    role: 'Advisory',
    members: 18,
    cadence: 'Weekly',
    status: 'Active',
  },
];

const CommitteeTable = () => {
  return (
    <div className="bg-white rounded-3xl shadow-sm border border-slate-100 overflow-hidden">
      <TableToolbar />

      <CommitteeTableHeader />

      <div>
        {committeesData.map((committee) => (
          <CommitteeRow key={committee.id} committee={committee} />
        ))}
      </div>

      <TablePagination />
    </div>
  );
};

export default CommitteeTable;
